import React from 'react';
import { Typography } from '@wds/typography';
import usePricingFooterStyles from '~pricing/components/PricingFooter/useStyles';

export default function FAQAnswer({ children }: { children: React.ReactNode }): JSX.Element {
  const { Answer } = usePricingFooterStyles();

  return (
    <div className={Answer}>
      <Typography variant="body" data-testid="FAQAnswer">
        {children}
      </Typography>
    </div>
  );
}
